import { render, staticRenderFns } from "./TrainingWebhooksForm.vue?vue&type=template&id=d19fe0d8&"
import script from "./TrainingWebhooksForm.vue?vue&type=script&lang=js&"
export * from "./TrainingWebhooksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports